<template>
  <component
    v-if="IconComponent"
    :is="IconComponent"
    :height="iconSize"
    :width="iconSize"
    :class="[iconMinSizeClass, variantClasses]"
    v-bind="$attrs"
  />
</template>

<script setup lang="ts">
import { Icon, type IconType } from '@/assets/svg';
import { computed } from 'vue';

type Size = 'sm' | 'md' | 'lg';
type Variant = 'neutral' | 'success' | 'danger' | 'info' | 'warning';

const props = withDefaults(
  defineProps<{
    icon?: IconType | null;
    size?: Size;
    variant?: Variant;
    spacing?: boolean;
  }>(),
  {
    size: 'md',
    spacing: true,
  }
);

const iconSizes: Record<Size, string> = {
  sm: '16px',
  md: '24px',
  lg: '32px',
};

// fix for firefox browser
const iconMinSizeClasses: Record<Size, string> = {
  sm: 'min-w-4 min-h-4',
  md: 'min-w-6 min-h-6',
  lg: 'min-w-8 min-h-8',
};

const iconMinSizeClass = computed(() => iconMinSizeClasses[props.size]);

const iconColorClasses: Record<Variant, string> = {
  neutral: 'text-wtg-neutral',
  success: 'text-wtg-success',
  danger: 'text-wtg-danger',
  info: 'text-wtg-info',
  warning: 'text-wtg-warning',
};

const iconSize = computed(() => iconSizes[props.size]);
const IconComponent = computed(() => (props.icon ? Icon[props.icon] : null));
const variantClasses = computed(() => (props.variant ? iconColorClasses[props.variant] : ''));
</script>
